// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"2c41d653","140":"4a354c25"}[chunkId] + ".chunk.css";
};